import {Injectable} from '@angular/core';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';
import {Tokens} from 'marked';
import {MarkedService} from './marked.service';

export interface Headline {
  text: string;
  depth: number;
  anchor: string;
}

export interface MarkdownParserResult {
  content: SafeHtml;
  headlines?: Headline[];
}

@Injectable({
  providedIn: 'root',
})
export class MarkdownParserService {
  constructor(private readonly domSanitizer: DomSanitizer, private readonly markedService: MarkedService) {
  }

  process(markdown: string): Promise<MarkdownParserResult> {
    const tokens = this.markedService.lex(markdown);

    const slugger = this.markedService.createSlugger();
    const headlines: Headline[] = tokens
      .filter(token => token.type === 'heading')
      .map((token: Tokens.Heading) => ({ text: token.text, depth: token.depth--, anchor: slugger.slug(token.text) }));

    const first = tokens.findIndex(token => token.type === 'heading' && token.depth === 0);
    if (first !== -1) {
      tokens.splice(first, 1);
    }

    const result = this.markedService.parse(tokens);
    const content = this.domSanitizer.bypassSecurityTrustHtml(result);

    return Promise.resolve({ content, headlines });
  }
}
